import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { clientType, getClientType } from 'Environment/getClientType';
import { isChromeAppOrChromeOS, isNativeClient } from 'Environment/launchResource/device';

//allow-unused-export: for unit testing
export function isAppProtectEnabledByOnPremAdmin(
	workspaceConfiguration: WorkspaceConfiguration
) {
	return workspaceConfiguration?.appProtection?.enabled?.toLowerCase() === 'on';
}

//This code is direct port of the code from PurpleUI
export function shouldSupportAppProtectionOnPrem(
	workspaceConfiguration: WorkspaceConfiguration
) {
	//Native apps will add the X-Citrix-AppProtection-Capable them-self
	if (isNativeClient() || !isAppProtectEnabledByOnPremAdmin(workspaceConfiguration)) {
		return false;
	}

	const { html5 } = workspaceConfiguration?.pluginAssistant || {};
	const ishtml5AlwaysEnabled = html5?.enabled === 'Always';
	// Return true only if app protection is enabled and the client is not HTML5 or Chrome OS
	const currentClientType = getClientType();
	return (
		!ishtml5AlwaysEnabled &&
		currentClientType !== clientType.html5 &&
		currentClientType !== clientType.chromeapp &&
		!isChromeAppOrChromeOS()
	);
}
